import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"
import { usePublicPresentation } from "~/containers/PublicPresentation/public-presentation-context"

import type { ProposalVppIncentiveDto } from "../dto/proposal-vpp-incentive.dto"
import { proposalVppIncentiveService } from "../services/proposal-vpp-incentive.service"

export default function useFetchProposalVppIncentives(
  proposalId: string | undefined,
): UseQueryResult<ProposalVppIncentiveDto[], unknown> {
  const presentation = usePublicPresentation()
  return useQuery({
    queryKey: presentation
      ? queryKeys.publicPresentation.vpp(proposalId)
      : queryKeys.proposalVppIncentives.byProposal(proposalId),
    queryFn: () =>
      presentation
        ? Promise.resolve(presentation.vppIncentives)
        : proposalVppIncentiveService.fetchAssociations(proposalId!),
    initialData: presentation?.vppIncentives,
    enabled: !presentation && !!proposalId,
  })
}
